import { createTheme } from "@mui/material"

export const mainTheme = createTheme({

});
